<app-layout [type]="layoutType">
  <div class="invite-landing">
    <app-title title="invite.title" />
    @if (unavailable) {
    <div class="error" data-testid="invite-unavailable">{{ 'invite.unavailable' | translate }}</div>
    } @else {
    <p class="hint" data-testid="invite-verifying">{{ 'invite.verifying' | translate }}</p>
    <app-spinner></app-spinner>
    }
  </div>
</app-layout>
